// removed by extract-text-webpack-plugin
module.exports = {"player-name":"GZ9onxQOZpmWmSkuybxd0_0","policy":"_1zq1LEZazbwlRnz_Bfn-ke_0","liberal":"lvOM43nORnXbZj-cJ6JV4_0","fascist":"_1GjkgF_vgCyepLAzwknodL_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3663793e","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.player/ui/events/events/policy/preview.vue
// module id = 201
// module chunks = 0